/**
 * An id this browser mints for something the server has not seen yet.
 *
 * TWO THINGS NEED ONE. The composer's upload chips (`up-`), which exist while the bytes are
 * going up and are gone the moment the message is sent, and the outbox's sends (`snd-`), whose
 * id is ALSO the §11 idempotency key — so the retry of a failed send must carry the id the first
 * attempt carried, or the message the server already stored is stored twice.
 *
 * WHY IT IS ONE FUNCTION. `useChatAttachments` and `useChatThread` each had their own copy,
 * identical but for the prefix, each with its own paragraph explaining the fallback. Two copies
 * of a rule about uniqueness is how one of them quietly loses the guard.
 *
 * `crypto.randomUUID` IS NOT ALWAYS THERE. It is absent on an insecure origin — which is exactly
 * how this application is reached on a warehouse machine addressed by IP — and in some test
 * environments. The id only has to be unique within one composer's lifetime, so a timestamp and
 * a random suffix is an honest fallback rather than a compromise; the prefix keeps the two kinds
 * legible in a stack trace.
 */
export function localId(prefix: string): string {
  const uuid = globalThis.crypto?.randomUUID?.();
  return `${prefix}-${uuid ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`}`;
}
